import { render, staticRenderFns } from "./EditOptionDialog.vue?vue&type=template&id=03c96dce"
import script from "./EditOptionDialog.vue?vue&type=script&lang=ts"
export * from "./EditOptionDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditOptionDialog.vue?vue&type=style&index=0&id=03c96dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports